import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { API_URL } from "../../../Services/Constant";


const token = localStorage.getItem("access_token")

const initialState = {
    user: null,
    loading: false,
};

export const getUser = createAsyncThunk(
    "/user/get-user-profile",
    async () => {
        const res = await fetch(API_URL + "/user/get-user-profile", {
            method: "GET",
            headers: {
                "Content-Type": "application/json",
                "Authorization": "Bearer " + token,

            },
        });
        const data = await res.json();
        return data;
    }
);

export const userSlice = createSlice({
    name: "user",
    initialState,
    reducers: {
        logout: (state) => {
            state.token = "";
            state.user = null;
            localStorage.removeItem("access_token");
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(getUser.pending, (state) => {
                state.loading = true;
            })
            .addCase(getUser.fulfilled, (state, { payload }) => {
                state.loading = false;
                state.user = payload?.response?.data;
            })
            .addCase(getUser.rejected, (state) => {
                state.loading = false;
            });
    },
});

export const userReducer = userSlice.reducer;
export const { logout } = userSlice.actions;
